export const environment = {
  production: false,
  platform: 'DTH',
  timezone: 'Brazil/East',
  validQualifiers: ['DJCTQ'],
  langFilters: ['pt','pt-br','en'],
  defaultLang: 'pt-br',
  apiUrl: 'https://daqd1lqonl.execute-api.us-west-2.amazonaws.com/api'
};

